import React from 'react';
import {connect} from 'react-redux';
import {Pane, Part} from '../commons/Panes';
import {Countries} from '../../redux/_commons/const';
import {changeSkiresort} from '../../redux/global/actions';
import * as moment from 'moment';

import '../../styles/panels.less';
import '../../styles/app.less';


/** Panneau de changement de station */
@connect(
  state => ({user: state.user}),
  {changeSkiresort}
)
export default class SkiresortSwitch extends React.Component {

  render() {

    const user = this.props.user.infos;
    const selectedSkiResort = this.props.user.selectedSkiresort;
    const changeSkiresort = this.props.changeSkiresort;
    const onSelect = (sr) => {
      if (sr.id !== selectedSkiResort.id) {
        changeSkiresort(sr);
        this.props.onEnd();
      }
    };

    return (
      <Pane title="Changer de station" className="skiresort-switch">
        {
          Countries.map(countryName => {
            return <Part title={ countryName } key={countryName}>
              { user.ski_resorts
                .filter(sr => sr.country === countryName)
                .map(sr => <SkiresortItem skiresort={sr}
                                          selected={selectedSkiResort.id === sr.id} key={sr.id}
                                          onSelect={onSelect}/>) }
            </Part>;
          })
        }
      </Pane>
    )
  }
}

/** Element de la liste des stations */
let SkiresortItem = ({skiresort, selected, onSelect}) => {

  let classes = ['item'];
  let opened = +moment.utc(skiresort.openingDate, 'YYYY-MM-DD HH:mm:SS') <= moment.now() && +moment.utc(skiresort.closingDate, 'YYYY-MM-DD HH:mm:SS') >= moment.now()
  if (opened) {
    classes.push('opened-resort');
  }
  if (selected) {
    classes.push('selected');
  }
  return (
    <div className={classes.join(' ')}
         onClick={() => onSelect(skiresort)}>
        <div className={['status-badge', opened ? 'opened' : 'closed'].join(' ')} data-toggle="tooltip" title=
          {opened ? 'Station ouverte' : 'Station fermée'}></div>
      <span>{skiresort.name}</span>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/admin/SkiresortSwitch.js